import React, { useState } from 'react';

const PopupForm = ({ isVisible, onClose, onSubmit, product, position }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [quantity, setQuantity] = useState('');

  if (!isVisible) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ name, email, address, phone, productName: product.name, quantity });
    onClose(); // Close the form after submission
  };

  return (
    <div
      className="absolute z-50 bg-white p-6 rounded-lg shadow-lg w-80"
      style={{
        top: position.y + 20,
        left: position.x,
      }}
    >
      <h2 className="text-xl font-semibold mb-4">Enter Buying Details</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700">Your Full Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700">Product Name</label>
          <input
            type="text"
            value={product.name}
            readOnly
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm bg-gray-100 text-sm"
          />
        </div>
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700">Quantity</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm text-sm"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm text-sm"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700">Address</label>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm text-sm"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Phone Number</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm text-sm"
            required
          />
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="py-2 px-4 bg-gray-500 hover:bg-gray-600 text-white rounded-md"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md"
          >
            Submit
          </button>
        </div>
      </form>
      <span className="text-sm text-gray-500 block mt-3">*We will contact you after you submit</span>
    </div>
  );
};

export default PopupForm;
